
import type { ReactNode } from 'react';
import { CmsProvider } from '@/components/painel/cms/cms-context';
import { GuideFeedbackProvider } from '@/components/help-center/guide-feedback-context';
import { PowersCmsProvider } from '@/components/painel/powers/powers-cms-context';
import { AcesCmsProvider } from '@/components/painel/aces/aces-cms-context';

export function CmsRootProvider({ children }: { children: ReactNode }) {
  return (
    <CmsProvider>
      <GuideFeedbackProvider>
        <PowersCmsProvider>
          <AcesCmsProvider>{children}</AcesCmsProvider>
        </PowersCmsProvider>
      </GuideFeedbackProvider>
    </CmsProvider>
  );
}
